import React from 'react';
import '../less/index.less';
import Link from '../../NavigationLink';
import {DropDown, IDate} from '@ab/components';
import palette from '../../../palette';

const dropDownStyle = {
        idleBorderColor: 'transparent',
        focusBorderColor: 'transparent',
        hoverBorderColor: 'transparent',
        disabledBorderColor: 'transparent',
    },
    linkStyle = {
        fontWeight: palette.twSemi,
        fontSize: palette.tsSmall,
    };

const today = new IDate('today');

export default function template() {
    const {lang} = this.props;

    return (
        <footer className="module-footer">
            <div className="content">
                <div className="line">
                    <div className="menu-list">
                        <div className="menu-item">
                            <Link style={linkStyle} href="/">
                                {this.l10n('HEADER_MENU_WALLET')}
                            </Link>
                        </div>
                        <div className="menu-item">
                            <Link style={linkStyle} href="/deposit/my">
                                {this.l10n('HEADER_MENU_DEPOSIT')}
                            </Link>
                        </div>
                        <div className="menu-item">
                            <Link style={linkStyle} href="/credit">
                                {this.l10n('HEADER_MENU_CREDIT')}
                            </Link>
                        </div>
                        <div className="menu-item">
                            <Link style={linkStyle} href="/payments">
                                {this.l10n('HEADER_MENU_PAYMENTS')}
                            </Link>
                        </div>
                        <div className="menu-item">
                            <Link style={linkStyle} href="/subscriptions">
                                {this.l10n('HEADER_MENU_SUBSCRIPTIONS')}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="line">
                    <div className="licence">
                        <div>{this.l10n('FOOTER_LICENSE_1', {year: today.get('year')})}</div>
                        <div>{this.l10n('FOOTER_LICENSE_2')}</div>
                        <div>{this.l10n('FOOTER_LICENSE_3')}</div>
                    </div>
                    <div className="share">
                        <Link
                            className="share-link"
                            href="https://play.google.com/store/apps/details?id=ua.com.abank"
                            external
                        >
                            <span className="share-icon gp" />
                        </Link>
                        <Link
                            className="share-link"
                            href="https://apps.apple.com/ua/app/abank24/id1261267716?l=uk"
                            external
                        >
                            <span className="share-icon as" />
                        </Link>
                        <Link
                            className="share-link"
                            href="https://appgallery.huawei.com/app/C102212413?sharePrepath=ag&locale=uk_uk"
                            external
                        >
                            <span className="share-icon gall" />
                        </Link>
                        <div className="hotline">
                            <div className="hotline-tel">7776</div>
                            <div className="hotline-label">{this.l10n('FOOTER_HOTLINE_LABEL')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
